import React from 'react';

import { TableSort } from 'components/WrappedComponents/Table/types';

import Filters from './filters/filters';
import { SupervisionUserEventsFilterFormValues } from './types';

import './styles.less';

interface SupervisionHeaderProps<SortType extends string | undefined> {
  totalResult: number;
  filter: Partial<SupervisionUserEventsFilterFormValues>;
  setFilter: (value: Partial<SupervisionUserEventsFilterFormValues>) => void;
  sort: TableSort<SortType>;
}

function SupervisionHeader<SortType extends string | undefined>({
  totalResult,
  filter,
  setFilter,
}: SupervisionHeaderProps<SortType>): React.ReactElement {
  const countString = `${totalResult} ${
    totalResult > 1 ? 'évènements trouvés' : 'évènement trouvé'
  }`;

  return (
    <div>
      <div>
        <Filters filter={filter} setFilter={setFilter} />
      </div>
      <p className="vehicules-found">{countString}</p>
    </div>
  );
}

export default SupervisionHeader;
